import type { TrackingEvent, TrackingPayload } from '../types'

const useCustomEvents = (
  track: (event: TrackingEvent, payload: TrackingPayload) => any,
) => ({
  trackCatalogueOrder: () => track('catalogue_order', {}),
})

export default useCustomEvents
